// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"9067918f","220":"9067918f","453":"401403f1","458":"9067918f","839":"9067918f"}[chunkId] + ".chunk.js";
};